import Cookies, { CookieAttributes } from "js-cookie";

interface IUseStorage {
  cookie: typeof Cookies;
  session: typeof sessionStorage;
  local: typeof localStorage;
};

type TypeStorage = keyof IUseStorage;

const useStorageObj: IUseStorage = {
  cookie: Cookies,
  session: sessionStorage,
  local: localStorage,
};

class UseStorage {
  static set(storage: TypeStorage, key: string, value: string, options?: CookieAttributes) {
    if (storage === 'cookie') {
      return useStorageObj[storage].set(key, value, options);
    }

    return useStorageObj[storage].setItem(key, value);
  }

  static get(storage: TypeStorage, key: string) {
    if (storage === 'cookie') {
      return useStorageObj[storage].get(key);
    }

    return useStorageObj[storage].getItem(key);
  }

  static remove(storage: TypeStorage, key: string) {
    if (storage === 'cookie') {
      return useStorageObj[storage].remove(key);
    }

    return useStorageObj[storage].removeItem(key);
  }
}

class AppStorage {
  REMEMBER_ME_KEY = 'REMEMBER_ME';

  SetItem(key: string, value: string, storage: TypeStorage = 'cookie') {
    if (storage !== 'cookie') {
      return UseStorage.set(storage, key, value);
    }

    UseStorage.set('local', key, value);

    const rememberMe = this.GetRememberMe();
    UseStorage.set('cookie', key, value, { expires: rememberMe ? 365 * 10 : 30 });
  }

  GetItem(key: string, storage: TypeStorage = 'cookie'): string | null | undefined {
    if (storage !== 'cookie') {
      return UseStorage.get(storage, key);
    }

    const localValue = UseStorage.get('local', key);
    if (localValue !== null && localValue !== undefined) {
      return localValue;
    }
    return UseStorage.get('cookie', key);
  }

  RemoveItem(key: string, storage: TypeStorage = 'cookie') {
    if (storage !== 'cookie') {
      return UseStorage.remove(storage, key);
    }
    UseStorage.remove('local', key);
    UseStorage.remove('cookie', key);
  }

  SetRememberMe(rememberMe: boolean) {
    // Remember-me is always enabled; persist true for compatibility
    UseStorage.set('local', this.REMEMBER_ME_KEY, 'true');
  }

  private GetRememberMe(): boolean {
    // Always return true so storage operations use long-lived expiry
    return true;
  }
}

const instance = new AppStorage();
export default instance;
